import React, { useState } from "react";
import { BrowserRouter, Routes, Route, NavLink, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LayoutDashboard, TrendingUp, Package, IndianRupee, Settings, BookOpen, LogOut, Warehouse as WarehouseIcon } from "lucide-react";
import { login } from "./api";
import Dashboard from "./pages/Dashboard";
import SalesTrend from "./pages/SalesTrend";
import ProfitBySku from "./pages/ProfitBySku";
import ProfitByProduct from "./pages/ProfitByProduct";
import Inventory from "./pages/Inventory";
import Costs from "./pages/Costs";
import Products from "./pages/Products";
import Replenishment from "./pages/Replenishment";
import Warehouse from "./pages/Warehouse";
import "./App.css";

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 5 * 60 * 1000 } } });

function Login({ onLogin }) {
  const [user, setUser] = useState("admin");
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");
  const handle = async (e) => {
    e.preventDefault();
    try {
      const data = await login(user, pass);
      localStorage.setItem("dash_token", data.token);
      localStorage.setItem("dash_role", data.role);
      localStorage.setItem("dash_user", data.username);
      onLogin(data.role);
    } catch {
      setErr("Invalid credentials");
    }
  };
  return (
    <div className="login-wrap">
      <div className="login-box">
        <h1>Dynoble Analytics</h1>
        <p>Amazon Seller Dashboard</p>
        <form onSubmit={handle}>
          <input value={user} onChange={e => setUser(e.target.value)} placeholder="Username" />
          <input type="password" value={pass} onChange={e => setPass(e.target.value)} placeholder="Password" />
          {err && <span className="err">{err}</span>}
          <button type="submit">Sign in</button>
        </form>
      </div>
    </div>
  );
}

function Layout({ onLogout, role }) {
  const adminNav = [
    { to: "/", icon: <LayoutDashboard size={18} />, label: "Overview" },
    { to: "/trend", icon: <TrendingUp size={18} />, label: "Sales Trend" },
    { to: "/profit-product", icon: <BookOpen size={18} />, label: "Profit by Product" },


    { to: "/replenishment", icon: <Package size={18} />, label: "Replenishment" },
    { to: "/warehouse", icon: <WarehouseIcon size={18} />, label: "Warehouse" },
    { to: "/products", icon: <Settings size={18} />, label: "Map Products" },

  ];
  const warehouseNav = [
    { to: "/warehouse", icon: <WarehouseIcon size={18} />, label: "Warehouse Stock" },
    { to: "/replenishment", icon: <Package size={18} />, label: "Replenishment" },
  ];
  const nav = role === "warehouse" ? warehouseNav : adminNav;
  const home = role === "warehouse" ? "/warehouse" : "/";

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">Dynoble<span>Analytics</span></div>
        {role === "warehouse" && (
          <div style={{ padding: "4px 12px 12px", fontSize: "0.75rem", color: "#4361ee", fontWeight: 600 }}>
            Warehouse Manager
          </div>
        )}
        <nav>
          {nav.map(n => (
            <NavLink key={n.to} to={n.to} end={n.to === home} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
              {n.icon} {n.label}
            </NavLink>
          ))}
        </nav>
        <button className="logout-btn" onClick={onLogout}><LogOut size={16} /> Logout</button>
      </aside>
      <main className="main-content">
        <Routes>
          <Route path="/" element={role === "warehouse" ? <Navigate to="/warehouse" /> : <Dashboard />} />
          <Route path="/trend" element={<SalesTrend />} />

          <Route path="/profit-product" element={<ProfitByProduct />} />

          <Route path="/replenishment" element={<Replenishment />} />
          <Route path="/warehouse" element={<Warehouse />} />
          <Route path="/products" element={<Products />} />

          <Route path="*" element={<Navigate to={home} />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem("dash_token"));
  const [role, setRole] = useState(localStorage.getItem("dash_role") || "admin");
  const logout = () => { localStorage.removeItem("dash_token"); localStorage.removeItem("dash_role"); localStorage.removeItem("dash_user"); setLoggedIn(false); setRole("admin"); };
  const handleLogin = (userRole) => { setRole(userRole); setLoggedIn(true); };
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {loggedIn ? <Layout onLogout={logout} role={role} /> : <Login onLogin={handleLogin} />}
      </BrowserRouter>
    </QueryClientProvider>
  );
}
